import { useContext, useEffect, useState } from 'react'
import { AppState } from 'App';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const Calendar = ({dates, setShowCalendar}) => {

    const modifiersStyles = {
        navBar: {
            fontWeight: '300',
            fontSize:'14px',
        },
        DayPicker: {
            fontSize:'0.8rem'
        }
    };

    const [appState, setAppState] = useContext(AppState)
    const [selectedDay, setSelectedDay] = useState(null)

    function handleDayClick(day) {
        setSelectedDay(day)
        //setShowCalendar(false)
    }

    useEffect(() => {
        if (selectedDay !== null) {
            const longDate = selectedDay.toDateString();
            setAppState(prevState => ({...prevState,dateContext:longDate}))
        }
    },[selectedDay])

    return (
        <DayPicker
            onDayClick={handleDayClick}
            numberOfMonths={2}
            selectedDays={dates.map(date => new Date(date))}
            className="font-light border rounded-lg dark:bg-itemdark border-borderlight dark:border-borderdark bg-itemlight text-textlight dark:text-textdark 2xl:w-144 w-136"
            modifiersStyles={modifiersStyles}
        />
    );
}

export default Calendar
